module.exports = __webpack_public_path__ + "components/country-flag/static/hk-abfa2ba75a873db82a1e98ff3c0d56e2.svg";